(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('.drawer__close')?.addEventListener('click', this.close.bind(this));
      this.addEventListener('click', (event) => {
        if (event.target === this) this.close();
      });
    }

    close() {
      this.removeAttribute('open');
      document.body.style.overflow = '';
    }

    open(triggerElement) {
      this.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
      triggerElement?.focus();
    }

    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section) => {
        const elementToReplace = this.querySelector(`.drawer__${section.id}`);
        const html = parsedState.sections[section.id];
        elementToReplace.innerHTML = html;
      });
    }

    getSectionsToRender() {
      return [
        { id: 'cart-items', section: document.getElementById('cart-drawer').dataset.id },
        { id: 'cart-footer', section: document.getElementById('cart-drawer').dataset.id }
      ];
    }
  }

  customElements.define('cart-drawer', CartDrawer);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const viewGridBtn = document.querySelector('.js-view-grid');
  const viewListBtn = document.querySelector('.js-view-list');
  const productGrid = document.querySelector('.ee-collection__grid');

  if (viewGridBtn && viewListBtn && productGrid) {
    // Portrait tablets always start in list view; otherwise honor saved preference
    const savedView = localStorage.getItem('collectionView');
    const portraitTablet = window.matchMedia('(max-width: 1024px) and (orientation: portrait)');
    if (portraitTablet.matches || savedView !== 'grid') {
      setListView();
    } else {
      setGridView();
    }

    viewGridBtn.addEventListener('click', function() {
      setGridView();
    });

    viewListBtn.addEventListener('click', function() {
      setListView();
    });

    function setGridView() {
      productGrid.classList.remove('ee-collection__grid--list');
      viewGridBtn.classList.add('active');
      viewListBtn.classList.remove('active');
      localStorage.setItem('collectionView', 'grid');
    }

    function setListView() {
      productGrid.classList.add('ee-collection__grid--list');
      viewListBtn.classList.add('active');
      viewGridBtn.classList.remove('active');
      localStorage.setItem('collectionView', 'list');
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-card-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const carousels = document.querySelectorAll('.ee-card-carousel');

  carousels.forEach(carousel => {
    const track = carousel.querySelector('.ee-card-carousel__track');
    const prevBtn = carousel.querySelector('.ee-card-carousel__arrow--prev');
    const nextBtn = carousel.querySelector('.ee-card-carousel__arrow--next');

    if (!track) return;

    const cardWidth = track.querySelector('.ee-card-carousel__card')?.offsetWidth || 0;
    const gap = 24; // 1.5rem in pixels

    function scrollNext() {
      const scrollAmount = cardWidth + gap;
      track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }

    function scrollPrev() {
      const scrollAmount = cardWidth + gap;
      track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', scrollPrev);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', scrollNext);
    }

    // Update arrow visibility based on scroll position
    function updateArrows() {
      if (prevBtn) {
        prevBtn.style.opacity = track.scrollLeft <= 0 ? '0.3' : '1';
        prevBtn.style.pointerEvents = track.scrollLeft <= 0 ? 'none' : 'auto';
      }

      if (nextBtn) {
        const maxScroll = track.scrollWidth - track.clientWidth;
        nextBtn.style.opacity = track.scrollLeft >= maxScroll - 1 ? '0.3' : '1';
        nextBtn.style.pointerEvents = track.scrollLeft >= maxScroll - 1 ? 'none' : 'auto';
      }
    }

    track.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);
    updateArrows();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-category-circles"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.ee-category-circles');

  sections.forEach(section => {
    const gridWrapper = section.querySelector('.ee-category-circles__grid-wrapper');
    const grid = section.querySelector('.ee-category-circles__grid');
    const prevBtn = section.querySelector('.ee-category-circles__arrow--prev');
    const nextBtn = section.querySelector('.ee-category-circles__arrow--next');

    if (!grid || !gridWrapper) return;

    const itemWidth = grid.querySelector('.ee-category-circles__item')?.offsetWidth || 0;
    const gap = 24; // 1.5rem in pixels

    function scrollNext() {
      const scrollAmount = itemWidth + gap;
      grid.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }

    function scrollPrev() {
      const scrollAmount = itemWidth + gap;
      grid.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', scrollPrev);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', scrollNext);
    }

    // Update arrow visibility based on scroll position and content overflow
    function updateArrows() {
      const maxScroll = grid.scrollWidth - grid.clientWidth;
      const needsScroll = maxScroll > 1;

      if (prevBtn) {
        if (!needsScroll) {
          prevBtn.style.display = 'none';
        } else {
          prevBtn.style.display = 'flex';
          prevBtn.style.opacity = grid.scrollLeft <= 0 ? '0.3' : '1';
          prevBtn.style.pointerEvents = grid.scrollLeft <= 0 ? 'none' : 'auto';
        }
      }

      if (nextBtn) {
        if (!needsScroll) {
          nextBtn.style.display = 'none';
        } else {
          nextBtn.style.display = 'flex';
          nextBtn.style.opacity = grid.scrollLeft >= maxScroll - 1 ? '0.3' : '1';
          nextBtn.style.pointerEvents = grid.scrollLeft >= maxScroll - 1 ? 'none' : 'auto';
        }
      }

      updateScrollProgress();
    }

    const scrollBar = section.querySelector('.ee-category-circles__scroll-bar');
    const scrollThumb = section.querySelector('.ee-category-circles__scroll-thumb');

    function updateScrollProgress() {
      if (!scrollBar || !scrollThumb) return;
      const maxScroll = grid.scrollWidth - grid.clientWidth;
      if (maxScroll <= 1) {
        scrollBar.style.display = 'none';
        return;
      }
      scrollBar.style.display = '';
      const visibleRatio = grid.clientWidth / grid.scrollWidth;
      const thumbWidthPercent = Math.max(20, Math.min(100, visibleRatio * 100));
      scrollThumb.style.width = thumbWidthPercent + '%';

      const scrollProgress = grid.scrollLeft / maxScroll;
      const maxTranslate = scrollBar.clientWidth - scrollThumb.clientWidth;
      const translateX = Math.max(0, Math.min(maxTranslate, maxTranslate * scrollProgress));
      scrollThumb.style.transform = 'translateX(' + translateX + 'px)';
    }

    grid.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);
    
    // Initial check after images load
    const images = grid.querySelectorAll('img');
    if (images.length > 0) {
      Promise.all(Array.from(images).map(img => img.complete ? Promise.resolve() : new Promise(resolve => img.onload = resolve)))
        .then(updateArrows);
    } else {
      updateArrows();
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var mobileToggle = document.getElementById('ee-nav-toggle');
  var mobileDrawer = document.getElementById('ee-nav-drawer');
  var mobileCloseBtn = document.getElementById('ee-nav-close');
  var navOverlay = document.getElementById('ee-nav-overlay');
  var navTabs = document.querySelectorAll('.ee-nav__link[data-mega-id]');
  var megaMenus = document.querySelectorAll('.ee-mega');
  var mobileExpandBtns = document.querySelectorAll('.ee-nav-drawer__expand');

  function openMobileDrawer() {
    mobileDrawer.setAttribute('aria-hidden', 'false');
    navOverlay.setAttribute('aria-hidden', 'false');
    mobileToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    if (mobileCloseBtn) mobileCloseBtn.focus();
  }

  function closeMobileDrawer() {
    mobileDrawer.setAttribute('aria-hidden', 'true');
    navOverlay.setAttribute('aria-hidden', 'true');
    mobileToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    mobileToggle.focus();
  }

  function closeAllMegaMenus() {
    navTabs.forEach(function (tab) {
      tab.setAttribute('aria-expanded', 'false');
    });
    megaMenus.forEach(function (mega) {
      mega.setAttribute('aria-hidden', 'true');
      mega.classList.remove('is-open');
    });
  }

  // Mobile drawer toggle
  if (mobileToggle) {
    mobileToggle.addEventListener('click', openMobileDrawer);
  }
  if (mobileCloseBtn) {
    mobileCloseBtn.addEventListener('click', closeMobileDrawer);
  }
  if (navOverlay) {
    navOverlay.addEventListener('click', closeMobileDrawer);
  }

  // Escape key closes all
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMobileDrawer();
      closeAllMegaMenus();
    }
  });

  // Mobile sub-menu expand/collapse
  mobileExpandBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var isExpanded = btn.getAttribute('aria-expanded') === 'true';
      var subMenu = btn.closest('.ee-nav-drawer__item--has-sub').querySelector('.ee-nav-drawer__sub');

      // Close other open submenus
      mobileExpandBtns.forEach(function (otherBtn) {
        if (otherBtn !== btn) {
          otherBtn.setAttribute('aria-expanded', 'false');
          var otherSub = otherBtn.closest('.ee-nav-drawer__item--has-sub').querySelector('.ee-nav-drawer__sub');
          if (otherSub) otherSub.setAttribute('aria-hidden', 'true');
        }
      });

      btn.setAttribute('aria-expanded', !isExpanded);
      if (subMenu) subMenu.setAttribute('aria-hidden', isExpanded);
    });
  });

  // Desktop: Tab hover opens mega menu
  navTabs.forEach(function (tab) {
    var megaId = tab.getAttribute('data-mega-id');
    if (!megaId) return;
    var megaMenu = document.getElementById(megaId);
    if (!megaMenu) return;

    var parentItem = tab.closest('.ee-nav__item--has-mega');

    // Desktop: hover (only when >989px)
    parentItem.addEventListener('mouseenter', function () {
      if (window.innerWidth > 989) {
        closeAllMegaMenus();
        tab.setAttribute('aria-expanded', 'true');
        megaMenu.setAttribute('aria-hidden', 'false');
      }
    });

    parentItem.addEventListener('mouseleave', function () {
      if (window.innerWidth > 989) {
        tab.setAttribute('aria-expanded', 'false');
        megaMenu.setAttribute('aria-hidden', 'true');
      }
    });

    // Tablet (<=989px): click to toggle
    tab.addEventListener('click', function (e) {
      if (window.innerWidth <= 989) {
        e.preventDefault();
        var isExpanded = tab.getAttribute('aria-expanded') === 'true';
        closeAllMegaMenus();
        if (!isExpanded) {
          tab.setAttribute('aria-expanded', 'true');
          megaMenu.setAttribute('aria-hidden', 'false');
          megaMenu.classList.add('is-open');
        }
      }
    });
  });

  // Close mega menus when clicking outside
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.ee-nav__item--has-mega')) {
      closeAllMegaMenus();
    }
  });

  // Live Predictive Search Suggestions & App Compatibility
  var searchInput = document.getElementById('ee-header-search-input');
  var searchResults = document.getElementById('ee-search-results');
  var searchTimeout = null;

  if (searchInput && searchResults) {
    function closeSuggestions() {
      searchResults.hidden = true;
      searchResults.setAttribute('aria-hidden', 'true');
      searchResults.innerHTML = '';
    }

    searchInput.addEventListener('input', function() {
      var query = this.value.trim();
      clearTimeout(searchTimeout);

      if (query.length < 2) {
        closeSuggestions();
        return;
      }

      searchTimeout = setTimeout(function() {
        var suggestUrl = '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,query&resources[limit]=6&resources[options][unavailable_products]=hide';
        fetch(suggestUrl)
          .then(function(res) { return res.json(); })
          .then(function(data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            var queries = (data.resources && data.resources.results && data.resources.results.queries) || [];

            if (products.length === 0 && queries.length === 0) {
              closeSuggestions();
              return;
            }

            var html = '';

            if (queries.length > 0) {
              html += '<div class="ee-search-results__section">';
              html += '<h3 class="ee-search-results__heading">Popular Searches</h3>';
              html += '<ul class="ee-search-results__queries">';
              queries.forEach(function(q) {
                html += '<li><a href="/search?q=' + encodeURIComponent(q.text) + '">' + (q.styled_text || q.text) + '</a></li>';
              });
              html += '</ul></div>';
            }

            if (products.length > 0) {
              html += '<div class="ee-search-results__section ee-search-results__section--products">';
              html += '<h3 class="ee-search-results__heading">Products</h3>';
              html += '<ul class="ee-search-results__product-list" role="listbox">';
              products.forEach(function(p) {
                var img = '';
                if (p.featured_image) {
                  img = typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image.url || '');
                } else if (p.image) {
                  img = typeof p.image === 'string' ? p.image : (p.image.url || '');
                }

                var price = '';
                if (p.price != null && p.price !== '') {
                  var numPrice = parseFloat(p.price);
                  if (!isNaN(numPrice)) {
                    price = '$' + numPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                  }
                }

                var compPrice = '';
                if (p.compare_at_price_max && parseFloat(p.compare_at_price_max) > parseFloat(p.price)) {
                  var numComp = parseFloat(p.compare_at_price_max);
                  if (!isNaN(numComp)) {
                    compPrice = '$' + numComp.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                  }
                }

                var safeTitle = (p.title || '').replace(/</g, '&lt;').replace(/>/g, '&gt;');
                var safeVendor = (p.vendor || '').replace(/</g, '&lt;').replace(/>/g, '&gt;');

                html += '<li class="ee-search-results__product-item" role="option">';
                html += '<a href="' + p.url + '" class="ee-search-results__product-link">';
                html += '<div class="ee-search-results__product-img-wrap">';
                if (img) {
                  html += '<img class="ee-search-results__product-img" src="' + img + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" width="48" height="48" loading="lazy">';
                } else {
                  html += '<div class="ee-search-results__product-img-placeholder">';
                  html += '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>';
                  html += '</div>';
                }
                html += '</div>';
                html += '<div class="ee-search-results__product-info">';
                if (safeVendor) {
                  html += '<span class="ee-search-results__product-vendor">' + safeVendor + '</span>';
                }
                html += '<span class="ee-search-results__product-title">' + safeTitle + '</span>';
                html += '<div class="ee-search-results__product-prices">';
                if (price) {
                  html += '<span class="ee-search-results__product-price">' + price + '</span>';
                }
                if (compPrice) {
                  html += '<span class="ee-search-results__product-price--compare">' + compPrice + '</span>';
                }
                html += '</div>';
                html += '</div>';
                html += '</a></li>';
              });
              html += '</ul></div>';
            }

            html += '<div class="ee-search-results__footer">';
            html += '<a href="/search?q=' + encodeURIComponent(query) + '">View all results for "' + query.replace(/</g, '&lt;').replace(/>/g, '&gt;') + '" &rarr;</a>';
            html += '</div>';

            searchResults.innerHTML = html;
            searchResults.hidden = false;
            searchResults.setAttribute('aria-hidden', 'false');
          })
          .catch(function(err) {
            console.error('Search suggestions error:', err);
          });
      }, 200);
    });

    document.addEventListener('click', function(e) {
      if (!e.target.closest('.ee-header__search')) {
        closeSuggestions();
      }
    });

    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeSuggestions();
      }
    });
  }

  // Close mega menu on resize to desktop
  window.addEventListener('resize', function () {
    if (window.innerWidth > 989) {
      closeAllMegaMenus();
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-pre-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var slider = document.querySelector('[data-slider]');
  if (!slider) return;

  var slides = Array.from(slider.querySelectorAll('.ee-pre-header__slide'));
  var leftArrow = document.querySelector('.ee-pre-header__arrow--left');
  var rightArrow = document.querySelector('.ee-pre-header__arrow--right');

  if (slides.length <= 1) {
    if (leftArrow) leftArrow.style.visibility = 'hidden';
    if (rightArrow) rightArrow.style.visibility = 'hidden';
    return;
  }

  var currentIndex = 0;
  var autoTimer = null;

  function getSlideWidth() {
    return slides[0].offsetWidth || slider.offsetWidth;
  }

  function goToSlide(index) {
    currentIndex = (index + slides.length) % slides.length;
    slider.scrollTo({ left: currentIndex * getSlideWidth(), behavior: 'smooth' });
  }

  function startAuto() {
    stopAuto();
    autoTimer = setInterval(function() {
      goToSlide(currentIndex + 1);
    }, 4000);
  }

  function stopAuto() {
    if (autoTimer) clearInterval(autoTimer);
  }

  /* Re-snap to current slide on resize (orientation change etc.) */
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      slider.scrollTo({ left: currentIndex * getSlideWidth(), behavior: 'instant' });
    }, 100);
  });

  if (leftArrow) {
    leftArrow.addEventListener('click', function() {
      stopAuto();
      goToSlide(currentIndex - 1);
      startAuto();
    });
  }

  if (rightArrow) {
    rightArrow.addEventListener('click', function() {
      stopAuto();
      goToSlide(currentIndex + 1);
      startAuto();
    });
  }

  slider.addEventListener('mouseenter', stopAuto);
  slider.addEventListener('mouseleave', startAuto);

  /* Touch swipe support */
  var touchStartX = 0;
  slider.addEventListener('touchstart', function(e) {
    touchStartX = e.changedTouches[0].clientX;
    stopAuto();
  }, { passive: true });
  slider.addEventListener('touchend', function(e) {
    var dx = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(dx) > 30) goToSlide(dx > 0 ? currentIndex + 1 : currentIndex - 1);
    startAuto();
  }, { passive: true });

  startAuto();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-product-main"] && !Shopify.designMode) return;
  try {
    
(function() {
  function EEGallery(sectionId) {
    var root   = document.getElementById('ee-gallery-' + sectionId);
    if (!root) return;

    var slides  = Array.from(root.querySelectorAll('.ee-pdp__slide'));
    var thumbs  = Array.from(root.querySelectorAll('.ee-pdp__thumb'));
    var btnPrev = root.querySelector('[data-gallery-prev]');
    var btnNext = root.querySelector('[data-gallery-next]');
    var currentCounterEl = root.querySelector('[data-gallery-current]');
    var current = 0;

    if (slides.length <= 1) {
      if (btnPrev) { btnPrev.disabled = true; btnPrev.style.display = 'none'; }
      if (btnNext) { btnNext.disabled = true; btnNext.style.display = 'none'; }
    }

    function goTo(idx) {
      if (!slides.length) return;
      var targetIdx = Math.max(0, Math.min(idx, slides.length - 1));

      slides.forEach(function(s, i) {
        if (i === targetIdx) {
          s.classList.add('is-active');
          s.removeAttribute('aria-hidden');
        } else {
          s.classList.remove('is-active');
          s.setAttribute('aria-hidden', 'true');
        }
      });
      thumbs.forEach(function(t, i) {
        if (i === targetIdx) {
          t.classList.add('is-active');
          t.setAttribute('aria-pressed', 'true');
          if (typeof t.scrollIntoView === 'function') {
            t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        } else {
          t.classList.remove('is-active');
          t.setAttribute('aria-pressed', 'false');
        }
      });

      current = targetIdx;

      if (currentCounterEl) {
        currentCounterEl.textContent = current + 1;
      }
      if (btnPrev) btnPrev.disabled = current === 0;
      if (btnNext) btnNext.disabled = current === slides.length - 1;
    }

    if (btnPrev) {
      btnPrev.addEventListener('click', function(e) { e.preventDefault(); goTo(current - 1); });
    }
    if (btnNext) {
      btnNext.addEventListener('click', function(e) { e.preventDefault(); goTo(current + 1); });
    }

    // Touch & Swipe gesture engine
    var touchStartX = 0;
    var touchStartY = 0;
    var isSwiping = false;
    var stage = root.querySelector('.ee-pdp__stage');

    if (stage) {
      stage.addEventListener('touchstart', function(e) {
        if (!e.touches || !e.touches[0]) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        isSwiping = true;
      }, { passive: true });

      stage.addEventListener('touchmove', function(e) {
        if (!isSwiping || !e.touches || !e.touches[0]) return;
        var deltaX = e.touches[0].clientX - touchStartX;
        var deltaY = e.touches[0].clientY - touchStartY;
        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 10) {
          if (e.cancelable) e.preventDefault();
        }
      }, { passive: false });

      stage.addEventListener('touchend', function(e) {
        if (!isSwiping || !e.changedTouches || !e.changedTouches[0]) return;
        isSwiping = false;
        var touchEndX = e.changedTouches[0].clientX;
        var swipeThreshold = 40;
        if (touchEndX < touchStartX - swipeThreshold) {
          goTo(current + 1);
        } else if (touchEndX > touchStartX + swipeThreshold) {
          goTo(current - 1);
        }
      }, { passive: true });
    }

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        goTo(parseInt(thumb.dataset.thumb, 10));
      });
    });

    goTo(0);
  }

  function EEVariants(sectionId) {
    var cards   = Array.from(document.querySelectorAll('#ee-variants-' + sectionId + ' .ee-pdp__variant-card'));
    var hiddenInput = document.getElementById('ee-variant-input-' + sectionId);
    var priceEl = document.getElementById('ee-price-now-' + sectionId);
    var stockEl = document.getElementById('ee-stock-' + sectionId);
    var atcBtn  = document.getElementById('ee-atc-btn-' + sectionId);
    var labelEl = document.getElementById('ee-variant-label-' + sectionId);
    var gallery = document.getElementById('ee-gallery-' + sectionId);
    var track   = document.getElementById('ee-variants-' + sectionId);
    var btnPrev = document.getElementById('ee-variant-prev-' + sectionId);
    var btnNext = document.getElementById('ee-variant-next-' + sectionId);

    if (!cards.length) return;

    if (track && btnPrev && btnNext) {
      var cardStep = function() {
        return cards[0].offsetWidth + parseInt(getComputedStyle(track).gap || 0, 10);
      };
      var updateArrows = function() {
        var overflow = track.scrollWidth > track.clientWidth + 1;
        btnPrev.hidden = !overflow;
        btnNext.hidden = !overflow;
        btnPrev.disabled = track.scrollLeft <= 0;
        btnNext.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      };
      btnPrev.addEventListener('click', function() { track.scrollBy({ left: -cardStep() }); });
      btnNext.addEventListener('click', function() { track.scrollBy({ left: cardStep() }); });
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    }

    cards.forEach(function(card) {
      card.addEventListener('click', function() {
        if (card.classList.contains('is-sold-out')) return;

        cards.forEach(function(c) { c.classList.remove('is-active'); });
        card.classList.add('is-active');

        var radio = card.querySelector('.ee-pdp__variant-radio');
        if (radio) radio.checked = true;

        var id        = card.dataset.variantId;
        var price     = card.dataset.variantPrice;
        var available = card.dataset.variantAvailable === 'true';
        var mediaIdx  = parseInt(card.dataset.variantMedia, 10) || 0;
        var title     = card.dataset.variantTitle;

        if (hiddenInput) hiddenInput.value = id;
        if (priceEl)     priceEl.textContent = price;
        if (labelEl)     labelEl.textContent = title;

        var wlBtn = document.querySelector('#ee-pdp-' + sectionId + ' [data-ee-wishlist-toggle]');
        if (wlBtn) {
          wlBtn.dataset.variantId = id;
          if (window.eeWishlist) window.eeWishlist.syncToggles();
        }

        if (stockEl) {
          if (available) {
            stockEl.classList.remove('ee-pdp__stock--out');
            stockEl.innerHTML = '<svg class="ee-pdp__stock-icon" width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="currentColor"/><polyline points="7 12 10.5 15.5 17 9" stroke="white" stroke-width="2.2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg><span>' + (stockEl.dataset.inStock || 'In stock') + '</span>';
          } else {
            stockEl.classList.add('ee-pdp__stock--out');
            stockEl.innerHTML = '<span>' + (stockEl.dataset.outStock || 'Sold out') + '</span>';
          }
        }

        if (atcBtn) {
          var btnText = atcBtn.querySelector('.ee-pdp__atc-text') || atcBtn;
          if (available) {
            atcBtn.classList.remove('ee-pdp__atc--call-us');
            btnText.textContent = atcBtn.dataset.addText || 'Add to cart';
            if (atcBtn.tagName.toLowerCase() === 'button') {
              atcBtn.type = 'submit';
              atcBtn.removeAttribute('disabled');
              atcBtn.onclick = null;
            } else {
              atcBtn.setAttribute('href', 'javascript:void(0);');
              atcBtn.onclick = function() { window.addToCart(id, atcBtn); };
            }
          } else {
            atcBtn.classList.add('ee-pdp__atc--call-us');
            btnText.textContent = atcBtn.dataset.callUsText || 'CALL US: 888-707-3976';
            if (atcBtn.tagName.toLowerCase() === 'button') {
              atcBtn.type = 'button';
              atcBtn.onclick = function() {
                window.location.href = 'tel:' + (atcBtn.dataset.callUsPhone || '8887073976');
              };
            } else {
              atcBtn.setAttribute('href', 'tel:' + (atcBtn.dataset.callUsPhone || '8887073976'));
              atcBtn.onclick = null;
            }
          }
        }

        if (gallery && mediaIdx >= 0) {
          var thumbs = Array.from(gallery.querySelectorAll('.ee-pdp__thumb'));
          if (thumbs[mediaIdx]) thumbs[mediaIdx].click();
        }
      });
    });
  }

  function EEReadMore(id) {
    var sectionEl = document.getElementById('ee-pdp-' + id);
    if (!sectionEl) return;
    var wraps = sectionEl.querySelectorAll('.ee-pdp__highlights-wrap');
    if (!wraps.length) return;

    wraps.forEach(function(wrap) {
      var inner = wrap.querySelector('.ee-pdp__highlights-inner');
      var btn   = wrap.querySelector('.ee-pdp__read-more');
      if (!inner || !btn) return;
      if (inner.scrollHeight <= inner.offsetHeight + 4) {
        btn.style.display = 'none';
        return;
      }
      btn.addEventListener('click', function() {
        wrap.classList.add('is-expanded');
        btn.setAttribute('aria-expanded', 'true');
      });
    });
  }

  function EEAboutReadMore() {
    document.querySelectorAll('.ee-pdp__about-wrap').forEach(function(wrap) {
      var inner = wrap.querySelector('.ee-pdp__about-inner');
      var btn   = wrap.querySelector('.ee-pdp__about-read-more');
      if (!inner || !btn) return;
      if (inner.scrollHeight <= inner.offsetHeight + 4) {
        btn.style.display = 'none';
        return;
      }
      btn.addEventListener('click', function() {
        wrap.classList.add('is-expanded');
        btn.setAttribute('aria-expanded', 'true');
      });
    });
  }

  function EEAccessories(id) {
    var layout = document.getElementById('ee-accessories-' + id);
    if (!layout) return;
    var catBtns = layout.querySelectorAll('.ee-pdp__acc-cat');
    var cards   = layout.querySelectorAll('.ee-pdp__acc-card');
    if (!catBtns.length) return;

    function showCat(activeCat) {
      catBtns.forEach(function(b) {
        b.classList.toggle('is-active', b.dataset.accCat === activeCat);
      });
      cards.forEach(function(c) {
        c.hidden = (c.dataset.accCat !== activeCat);
      });
    }

    catBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        showCat(btn.dataset.accCat);
      });
    });
  }

  function EEQa(id) {
    var listEl   = document.getElementById('ee-qa-list-' + id);
    if (!listEl) return;
    var searchEl = document.querySelector('[data-qa-search="ee-qa-list-' + id + '"]');
    var loadBtn  = document.querySelector('[data-qa-list="ee-qa-list-' + id + '"]');
    var items    = Array.from(listEl.querySelectorAll('.ee-pdp__qa-item'));

    if (loadBtn) {
      loadBtn.addEventListener('click', function() {
        items.forEach(function(item) { item.classList.remove('ee-pdp__qa-hidden'); });
        loadBtn.hidden = true;
      });
    }

    if (searchEl) {
      searchEl.addEventListener('input', function() {
        var q = searchEl.value.trim().toLowerCase();
        items.forEach(function(item) {
          var text = item.textContent.toLowerCase();
          if (q === '') {
            var idx = parseInt(item.dataset.qaIndex, 10);
            item.classList.toggle('ee-pdp__qa-hidden', idx >= 4);
            item.hidden = false;
          } else {
            item.classList.remove('ee-pdp__qa-hidden');
            item.hidden = !text.includes(q);
          }
        });
        if (loadBtn) loadBtn.hidden = q !== '';
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.ee-pdp').forEach(function(el) {
      var id = el.id.replace('ee-pdp-', '');
      EEGallery(id);
      EEVariants(id);
      EEReadMore(id);
      EEAccessories(id);
      EEQa(id);
    });
    EEAboutReadMore();
  });

  // Protection plans toggle
  document.addEventListener('click', function(e) {
    var toggleLink = e.target.closest('.js-toggle-protection');
    if (toggleLink) {
      e.preventDefault();
      var protectionSection = toggleLink.closest('.ee-pdp__info, .ee-pdp').querySelector('[id^="ee-protection-"]');
      if (protectionSection) {
        var isHidden = protectionSection.style.display === 'none';
        protectionSection.style.display = isHidden ? 'block' : 'none';
        if (isHidden) {
          protectionSection.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
    }
  });

  // Add protection to cart
  window.addProtectionToCart = function(button) {
    var container = button.closest('.ee-protection');
    var selectedInput = container.querySelector('input[name^="protection_plan"]:checked');
    if (selectedInput) {
      var years = selectedInput.value;
      var price = selectedInput.closest('.ee-protection__option').querySelector('.ee-protection__price').textContent;
      alert('Added ' + years + ' year protection plan (' + price + ') to cart!');
    }
  };
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-rich-text-collapsible"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.js-read-more').forEach(button => {
  button.addEventListener('click', function() {
    const textContent = this.closest('.js-text-content');
    const isExpanded = textContent.getAttribute('data-expanded') === 'true';
    const readMoreText = this.querySelector('.js-read-more-text');
    const readLessText = this.querySelector('.js-read-less-text');

    if (isExpanded) {
      textContent.setAttribute('data-expanded', 'false');
      readMoreText.classList.remove('hidden');
      readLessText.classList.add('hidden');
    } else {
      textContent.setAttribute('data-expanded', 'true');
      readMoreText.classList.add('hidden');
      readLessText.classList.remove('hidden');
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-sub-categories"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const viewGridBtn = document.querySelector('.js-view-grid');
  const viewListBtn = document.querySelector('.js-view-list');
  const productGrid = document.querySelector('.ee-collection__grid');

  if (viewGridBtn && viewListBtn && productGrid) {
    const savedView = localStorage.getItem('collectionView');
    if (savedView === 'grid') {
      setGridView();
    } else {
      setListView();
    }

    viewGridBtn.addEventListener('click', setGridView);
    viewListBtn.addEventListener('click', setListView);

    function setGridView() {
      productGrid.classList.remove('ee-collection__grid--list');
      viewGridBtn.classList.add('active');
      viewListBtn.classList.remove('active');
      localStorage.setItem('collectionView', 'grid');
    }

    function setListView() {
      productGrid.classList.add('ee-collection__grid--list');
      viewListBtn.classList.add('active');
      viewGridBtn.classList.remove('active');
      localStorage.setItem('collectionView', 'list');
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ee-testimonial-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.ee-testimonial-carousel');

  sections.forEach(section => {
    const slides = section.querySelectorAll('.ee-testimonial-carousel__slide');
    const dots = section.querySelectorAll('.ee-testimonial-carousel__dot');
    const prevBtn = section.querySelector('.ee-testimonial-carousel__arrow--prev');
    const nextBtn = section.querySelector('.ee-testimonial-carousel__arrow--next');
    let currentIndex = 0;
    let autoRotateInterval;

    function showSlide(index) {
      slides.forEach((slide, i) => {
        slide.classList.remove('ee-testimonial-carousel__slide--active');
        if (i === index) {
          slide.classList.add('ee-testimonial-carousel__slide--active');
        }
      });

      dots.forEach((dot, i) => {
        dot.classList.remove('ee-testimonial-carousel__dot--active');
        if (i === index) {
          dot.classList.add('ee-testimonial-carousel__dot--active');
        }
      });

      currentIndex = index;
    }

    function nextSlide() {
      const nextIndex = (currentIndex + 1) % slides.length;
      showSlide(nextIndex);
    }

    function prevSlide() {
      const prevIndex = (currentIndex - 1 + slides.length) % slides.length;
      showSlide(prevIndex);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        prevSlide();
        resetAutoRotate();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        nextSlide();
        resetAutoRotate();
      });
    }

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        showSlide(index);
        resetAutoRotate();
      });
    });

    function startAutoRotate() {
      const rotateDelay = parseInt(section.dataset.rotateDelay) || 5000;
      autoRotateInterval = setInterval(nextSlide, rotateDelay);
    }

    function stopAutoRotate() {
      clearInterval(autoRotateInterval);
    }

    function resetAutoRotate() {
      stopAutoRotate();
      startAutoRotate();
    }

    startAutoRotate();

    section.addEventListener('mouseenter', stopAutoRotate);
    section.addEventListener('mouseleave', startAutoRotate);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["outlet-banner"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.js-video-popup').forEach(button => {
  button.addEventListener('click', () => {
    const modal = document.querySelector('.js-video-modal');
    if (modal) {
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  });
});

document.querySelectorAll('.js-video-overlay, .js-video-close').forEach(element => {
  element.addEventListener('click', () => {
    const modal = document.querySelector('.js-video-modal');
    if (modal) {
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  });
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    const modal = document.querySelector('.js-video-modal');
    if (modal && modal.getAttribute('aria-hidden') === 'false') {
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const viewGridBtn = document.querySelector('.js-view-grid');
  const viewListBtn = document.querySelector('.js-view-list');
  const productGrid = document.querySelector('.ee-collection__grid');

  if (viewGridBtn && viewListBtn && productGrid) {
    // Check for saved preference, default to list view
    const savedView = localStorage.getItem('searchView');
    if (savedView === 'grid') {
      setGridView();
    } else {
      setListView();
    }

    viewGridBtn.addEventListener('click', function() {
      setGridView();
    });

    viewListBtn.addEventListener('click', function() {
      setListView();
    });

    function setGridView() {
      productGrid.classList.remove('ee-collection__grid--list');
      viewGridBtn.classList.add('active');
      viewListBtn.classList.remove('active');
      localStorage.setItem('searchView', 'grid');
    }

    function setListView() {
      productGrid.classList.add('ee-collection__grid--list');
      viewListBtn.classList.add('active');
      viewGridBtn.classList.remove('active');
      localStorage.setItem('searchView', 'list');
    }
  }
});

  } catch(e) { console.error(e); }
})();
})();
